/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useStoreSelector } from 'store/hooks/storeHooks';
import Text from '../Text';

export const DropdownTrigger = ({
  title,
  dataQa,
  isSelected,
  onClick,
  rounded,
}: {
  title: any;
  isSelected: boolean;
  onClick: (e: any) => void;
  rounded?: boolean;
  height?: number;
  dataQa?: string;
}) => {
  const { currentTheme } = useStoreSelector((state) => state.pageLayout);
  const getQaData = (str) => {
    // eslint-disable-next-line unicorn/no-useless-undefined
    if (!str) return undefined;
    const t = str.toLowerCase();
    if (t === 'sort') {
      return 'mobile_sort';
    }

    if (t === 'year') {
      return 'mobile_release_date_year_bucket_filter';
    }

    if (t === 'instant') {
      return 'instant_ship_filter';
    }

    if (t === 'under retail') {
      return 'under_retail_filter';
    }

    if (t === 'available now') {
      return 'available_now_filter';
    }

    if (t === 'condition') {
      return 'mobile_product_condition_filter';
    }

    return `mobile_${t}_filter`;
  };
  return (
    <div
      className="tw-w-fit tw-h-[22px] tw-p-1 dropdown-trigger tw-cursor-pointer tw-text-center tw-inline-block tw-mr-2 tw-mb-2"
      onClick={onClick}
      style={{
        backgroundColor: isSelected ? currentTheme?.textColor || '#000000' : 'transparent',
        color: isSelected
          ? currentTheme?.backgroundColor || '#FFFFFF'
          : currentTheme?.textColor || '#000000',
        borderRadius: rounded ? '20px' : '0px',
        border: isSelected ? 'none' : `1px solid ${currentTheme?.borderColor || '#000000'}`,
        padding: rounded ? '3px 4px 4px' : '3px',
        whiteSpace: 'nowrap',
        fontSize: '11.5px',
      }}
      data-qa={dataQa || getQaData(title || '')}
    >
      <Text as="span" className="tw-leading-[11px]">
        {title}
      </Text>
    </div>
  );
};
